export const BLOG_STATUSES = ['current', 'draft'];
export const VIRTUAL_ROOT_ID = 'VIRTUAL_ROOT_ID';
export const PAGE_SIZE = 40;
export const INDENT_PER_LEVEL = 16;
